import type { ComponentType } from 'react'

import { CompactLayout } from './compact-layout.tsx'
import type { FieldLayoutProps, FormLayout } from './form-layout-context'
import { InlineLayout } from './inline-layout.tsx'
import { StackedFillLayout } from './stacked-fill-layout.tsx'
import { StackedLayout } from './stacked-layout.tsx'
import { TabularLayout } from './tabular-layout.tsx'

const layouts: Record<FormLayout, ComponentType<FieldLayoutProps>> = {
  stacked: StackedLayout,
  'stacked-fill': StackedFillLayout,
  inline: InlineLayout,
  compact: CompactLayout,
  tabular: TabularLayout,
}

export function getFormLayout(layout: FormLayout): ComponentType<FieldLayoutProps> {
  return layouts[layout]
}
